import { Component, Output, EventEmitter } from '@angular/core';
import { GlobalsService } from '../../services/globals.service';

@Component({
    selector: 'grid-search',
    templateUrl: './grid-search.component.html',
    styleUrls: ['./grid-search.component.scss'],
    standalone: false
})
export class GridSearchComponent {

  constructor(globals: GlobalsService) {

  }
  @Output() search = new EventEmitter<string>();

  hasSearchText: boolean = false;
  searchText: string = "";

  onKeyup(e: any) {
    this.searchText = e.srcElement.value;
    this.hasSearchText = this.searchText.length > 0;
    this.search.emit(this.searchText);
  }
  clearSearch() {
    this.searchText = "";
    this.search.emit(this.searchText);
  }

}
